/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromptContainer } from '../../models/prompt-container';

export interface PromptsSharedShareSlugGet$Params {
  shareSlug: string;
}

export function promptsSharedShareSlugGet(
  http: HttpClient,
  rootUrl: string,
  params: PromptsSharedShareSlugGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PromptContainer>> {
  const rb = new RequestBuilder(rootUrl, promptsSharedShareSlugGet.PATH, 'get');
  if (params) {
    rb.path('shareSlug', params.shareSlug, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PromptContainer>;
      }),
    );
}

promptsSharedShareSlugGet.PATH = '/prompts/shared/{shareSlug}';
